export default {
  apiKey: "AIzaSyCiXcU-W4EBETYz5hUSyAbvL1w7FQBJEns",
  authDomain: "cuprolli-hub.firebaseapp.com",
  databaseURL: "https://cuprolli-hub.firebaseio.com",
  projectId: "cuprolli-hub",
  storageBucket: "cuprolli-hub.appspot.com",
  messagingSenderId: "511505279500"
}
